// Apryse reports a page rotation only as a generic "content changed" page,
// so rotations are found by comparing each page's orientation against the
// snapshot taken before the change.

export const readPageRotations = (doc) => {
  if (!doc || typeof doc.getPageRotation !== "function") return [];
  const pageCount = doc.getPageCount?.() || 0;
  const rotations = [];
  for (let page = 1; page <= pageCount; page += 1) {
    rotations.push(doc.getPageRotation(page) || 0);
  }
  return rotations;
};

// Returns [{ page, degrees }] with degrees as the clockwise turn (90/180/270).
export const diffPageRotations = (before, after) => {
  if (!Array.isArray(before) || !Array.isArray(after)) return [];
  if (before.length !== after.length) return [];
  const rotations = [];
  after.forEach((current, index) => {
    const degrees = (((current - before[index]) % 360) + 360) % 360;
    if (degrees) rotations.push({ page: index + 1, degrees });
  });
  return rotations;
};

// Folds pending and new turns per page, dropping pages that net to zero.
export const mergePageRotations = (pending, incoming) => {
  const byPage = new Map();
  [...pending, ...incoming].forEach(({ page, degrees }) => {
    byPage.set(page, ((byPage.get(page) || 0) + degrees) % 360);
  });
  return [...byPage.entries()]
    .filter(([, degrees]) => degrees)
    .sort(([a], [b]) => a - b)
    .map(([page, degrees]) => ({ page, degrees }));
};

export const hasStructuralPageChange = (changes) => {
  if (Array.isArray(changes)) {
    return changes.some((change) =>
      ["inserted", "removed", "reordered"].includes(change?.type)
    );
  }
  return Boolean(
    changes?.added?.length ||
      changes?.removed?.length ||
      (changes?.moved && Object.keys(changes.moved).length)
  );
};
